import { Card, Fab, Grid, Icon, lighten, styled, useTheme } from '@mui/material';
import { useTotalLiveProductCount, useTotalOnlineRiderCount, useTotalProductCount, useTotalRiderCount, useTotalSellerCount, useTotalUser } from '../../../requests/dashboard';
import useAuth from '../../../hooks/useAuth';

const ContentBox = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
}));

const FabIcon = styled(Fab)(() => ({
  width: '44px !important',
  height: '44px !important',
  boxShadow: 'none !important',
}));

const H3 = styled('h3')(({ textcolor }) => ({
  margin: 0,
  color: textcolor,
  fontWeight: '500',
  marginLeft: '12px',
}));

const H1 = styled('h1')(({ theme }) => ({
  margin: 0,
  flexGrow: 1,
  color: theme.palette.text.secondary,
}));



const IconBox = styled('div')(() => ({
  width: 16,
  height: 16,
  color: '#fff',
  display: 'flex',
  overflow: 'hidden',
  borderRadius: '300px ',
  justifyContent: 'center',
  '& .icon': { fontSize: '14px' },
}));

const StatCards2 = ({ dashboard_data }) => {
  const { palette } = useTheme();
  const bgError = lighten(palette.error.main, 0.85);

  const { data: totalProduct } = useTotalProductCount();
  const { data: totalLiveProduct } = useTotalLiveProductCount();


  const { data: totalRiderCount } = useTotalRiderCount();
  const { data: totalOnlineRiderCount } = useTotalOnlineRiderCount();


  const { data: totalUserCount } = useTotalUser();
  const { data: totalSellerCount } = useTotalSellerCount();


  const user = useAuth();
  if (user?.user?.service_area_id) {
    return <></>
  }




  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/people.png' width={30} height={30} />
            </FabIcon>
            <H3 >Total User</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalUserCount}</H1>
            <IconBox sx={{ background: 'rgba(9, 182, 109, 0.15)' }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/seller.png' width={30} height={30} />
            </FabIcon>
            <H3 >Total Seller</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalSellerCount ?? 0}</H1>
            <IconBox sx={{ background: bgError }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>



      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/box.png' width={30} height={30} />
            </FabIcon>
            <H3 >Total Products</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalProduct ?? 0}</H1>
            <IconBox sx={{ background: 'rgba(9, 182, 109, 0.15)' }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/box-active.png' width={30} height={30} />
            </FabIcon>
            <H3 >Live Products</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalLiveProduct ?? 0}</H1>
            <IconBox sx={{ background: 'rgba(9, 182, 109, 0.15)' }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>




      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/delivery-bike.png' width={30} height={30} />
            </FabIcon>
            <H3 >Total Rider</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalRiderCount ?? 0}</H1>
            <IconBox sx={{ background: 'rgba(9, 182, 109, 0.15)' }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>


      <Grid item xs={12} md={6}>
        <Card elevation={3} sx={{ p: 2 }}>
          <ContentBox>
            <FabIcon size="medium" sx={{ overflow: 'hidden' }}>
              <img src='/icons/delivery-bike-active.png' width={30} height={30} />
            </FabIcon>
            <H3 >Available Rider</H3>
          </ContentBox>

          <ContentBox sx={{ pt: 2 }}>
            <H1>{totalOnlineRiderCount ?? 0}</H1>
            <IconBox sx={{ background: 'rgba(9, 182, 109, 0.15)' }}>
              <Icon className="icon">expand_less</Icon>
            </IconBox>
            {/* <Span >(+21%)</Span> */}
          </ContentBox>
        </Card>
      </Grid>

    </Grid >
  );
};

export default StatCards2;
